import React from "react";
import { useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import inno from "../../assets/innoAlRe/innolunga.png";
import osteria from "../../assets/osteria/1.JPG";
import matri from "../../assets/matrimonio/1.JPG";
import molinara from "../../assets/molinara/room1.JPG";
import barbiere from "../../assets/barbiere/1.JPG";
const preloadImages = (imageSources) => {
  imageSources.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};
const RoomTab = ({ isRooms }) => {
  const tabs = [
    {
      roomCode: "room1",
      id: 1,
      label: "INNO AL RE",
      link: "/rooms/1",
      src: inno,
    },
    {
      roomCode: "room2",
      id: 2,
      label: "IL BARBIERE DI SIVIGLIA",
      link: "/rooms/2",
      src: barbiere,
    },
    {
      roomCode: "room3",
      id: 3,
      label: "L’OSTERIA DI MARECHIARO",
      link: "/rooms/3",
      src: osteria,
    },
    {
      roomCode: "room4",
      id: 4,
      label: "LA MOLINARA",
      link: "/rooms/4",
      src: molinara,
    },
    {
      roomCode: "room5",
      id: 5,
      label: "IL MATRIMONIO INASPETTATO",
      link: "/rooms/5",
      src: matri,
    },
  ];

  useEffect(() => {
    preloadImages(tabs.map((tab) => tab.src));
  }, [tabs]);
  return (
    <Stack
      direction="row"
      sx={{
        flexWrap: "wrap",
        justifyContent: "center",
        width: "100%",
      }}
    >
      {tabs.map((item, index) => (
        <Link
          key={item.id}
          to={item.link}
          style={{
            textDecoration: "none",
            display: "inline-block",
            overflow: "hidden",
            width: !isRooms ? "18%" : index === 0 ? "97%" : "48%",
            paddingTop: "18%", // Mantiene il rapporto 1:1
            position: "relative",
            margin: "0.5%",
          }}
        >
          {/* Immagine di sfondo */}
          <img
            src={item.src}
            alt={`Instagram link ${index + 1}`}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.3s ease-in-out",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform =
                "translate(-50%, -50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform =
                "translate(-50%, -50%) scale(1)";
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(87, 87, 87, 0.407)", // Layer scuro semi-trasparente
              zIndex: 1, // Assicura che il layer sia sopra l'immagine ma sotto il testo
            }}
          />
          {/* Testo centrato sopra l'immagine */}
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "white",
              textAlign: "center",
              zIndex: 2, // Assicura che il testo sia sopra il layer scuro
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: isRooms ? "2.5vw" : "28px",
                letterSpacing: "2px",
                fontFamily: "ivymode",
                lineHeight: 1.3,
                fontWeight: 500,
              }}
            >
              {item.label} {/* Nome della camera */}
            </Typography>
          </Box>
        </Link>
      ))}
    </Stack>
  );
};

export default RoomTab;
